import { removeContactsFromMediaLists } from '@media-lists/services/mediaListsService';
import { ContactDuplicateGroup, ContactDuplicateId } from '@src/types/duplicateContacts';
import { getContactIdsToRemoveByList } from '@src/utils/duplicateContacts';

export const resolveDuplicatedContacts = async (
  duplicatedContacts: ContactDuplicateGroup[],
  selectedContactIds: ReadonlySet<ContactDuplicateId>,
  targetMediaListsId: number[],
  contactIdsNotOnListsYet: ReadonlySet<ContactDuplicateId> = new Set(),
) => {
  const contactIdsToRemoveByList = getContactIdsToRemoveByList(
    duplicatedContacts,
    selectedContactIds,
    targetMediaListsId,
    contactIdsNotOnListsYet,
  );

  await Promise.all(
    [...contactIdsToRemoveByList.entries()]
      .filter(([, contactIds]) => contactIds.length > 0)
      .map(([listId, contactIds]) => removeContactsFromMediaLists(contactIds, String(listId))),
  );
};
